import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { theme } from 'src/template';
import styled from 'styled-components';
export default function Opening(_ref) {
  var opening = _ref.opening,
      upcoming = _ref.upcoming;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var currentDayOfWeek = daysOfWeek[new Date().getDay()];
  var currentHours = new Date().getHours() * 3600;
  var currentMinutes = new Date().getMinutes() * 60;
  var currentTime = currentHours + currentMinutes;
  var isBetweenHoursIndex = opening[currentDayOfWeek].hours.findIndex(function (hour) {
    return currentTime >= hour.startAt && currentTime <= hour.endAt;
  });

  if (upcoming) {
    return /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Upcoming, {}), t('restaurant.availableSoon')]
    });
  }

  if (!opening[currentDayOfWeek].isActive || isBetweenHoursIndex === -1) {
    return /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Closed, {}), t('restaurant.closed')]
    });
  }

  var closingHour = opening[currentDayOfWeek].hours[isBetweenHoursIndex].endAt;
  var minutes = Math.floor(closingHour / 60 % 60);
  var hours = Math.floor(closingHour / (60 * 60) % 24);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Open, {}), t('restaurant.openUntil', {
      hours: hours,
      minutes: minutes === 0 ? '' : minutes
    })]
  });
}
var Container = styled.div.withConfig({
  displayName: "opening__Container",
  componentId: "sc-1egce9v-0"
})(["@media screen and (min-width:750px){margin-bottom:10px;}"]);
var Open = styled.span.withConfig({
  displayName: "opening__Open",
  componentId: "sc-1egce9v-1"
})(["background-color:", ";border-radius:50px;display:inline-block;height:9px;margin-right:7px;margin-top:12px;width:9px;"], theme.colors.success);
var Closed = styled.span.withConfig({
  displayName: "opening__Closed",
  componentId: "sc-1egce9v-2"
})(["background-color:", ";border-radius:50px;display:inline-block;height:9px;margin-right:7px;margin-top:12px;width:9px;"], theme.colors.alert);
var Upcoming = styled.span.withConfig({
  displayName: "opening__Upcoming",
  componentId: "sc-1egce9v-3"
})(["background-color:", ";border-radius:50px;display:inline-block;height:9px;margin-right:7px;margin-top:12px;width:9px;"], theme.colors.secondary);